import {LoadingState, LoadingStyle} from './loading.reducer.types';

const initialState: LoadingState = {
	isShowing: true,
	style: LoadingStyle.OPAQUE
};

export const loadingReducer = (previousState = initialState, action): LoadingState => {
	console.log(action);

	if (action.showLoading || action.payload?.showLoading || action.meta?.showLoading) {
		return {
			...previousState,
			isShowing: true,
			style: action.showLoading || action.payload?.showLoading || action.meta?.showLoading
		}
	} else if (action.showLoading === false || action.payload?.showLoading === false || action.meta?.showLoading === false) {
		return {
			...previousState,
			isShowing: false,
			style: null
		}
	}

	return previousState;
};
